<template>
  <section
    class="component-d339d3de"
    resmed-component-name="multistep_5_icon-line_text"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': acf.layout['background-color'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col-md-10 text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h2 v-html="acf.headline"></h2>
          </div>
        </div>
        <div class="items text-center">
          <div class="item" v-for="item in acf.items">
            <figure>
              <img class="img-fluid" v-bind:src="`${item.icon}`" alt="" />
            </figure>
            <h4 v-bind:class="[item.color]">{{ item.title }}</h4>
            <p class="content" v-html="item.description"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-d339d3de", // multistep_5_icon-line_text
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-d339d3de {
  padding: 6rem 0 4rem 0;
}

.component {
  h2 {
    position: relative;
    margin: 0 0 1rem 0;

    @extend %eyebrow-center;
  }

  h4 {
    margin-bottom: 0.75rem;
  }

  .items {
    @media (min-width: 768px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }

    .item {
      padding: 2rem 2rem 1rem 2rem;
      max-width: 350px;

      @media (max-width: 767px) {
        margin: 0 auto;
      }

      @media (min-width: 992px) {
        max-width: 440px;
      }

      @media (min-width: 1200px) {
        min-width: 300px;
      }

      figure {
        max-width: 4.5rem;
        margin: 0 auto 1rem auto;

        img {
          display: block;
        }
      }
    }
  }
}
</style>